export default __webpack_public_path__ + "static/media/1-1-2.3496043e.jpg";